import { LAYER_TYPE } from '../layer'
import { ALayer } from './ALayer'
import { NbdsVectorLayer } from './NbdsVectorLayer'

export function LayerDataCreate(type, layer) {
  switch (type) {
    case LAYER_TYPE.NBDS_VECTO_LAYER:
      return new NbdsVectorLayer(layer)
    default:
      return new ALayer(layer)
  }
}
